import { ERROR_MESSAGES, PUSHER_ERROR_CODES } from '../../constants/pusher';
import type { TXDeviceManager } from '../../types/txlive-pusher';
import type { TXPushObserver } from '../../types/txlive-pusher';

type TXLivePusherConstructor = new () => {
  videoView: HTMLVideoElement;
  getDeviceManager: () => TXDeviceManager;
  setObserver: (observer: TXPushObserver | Record<string, never>) => void;
  setRenderView: (containerId: string | HTMLDivElement) => HTMLVideoElement;
  setVideoQuality: (quality: string) => void;
  setAudioQuality: (quality: string) => void;
  setProperty: (key: string, value: unknown) => void;
  startCamera: (deviceId?: string) => Promise<string>;
  stopCamera: () => void;
  startMicrophone: (deviceId?: string) => Promise<string>;
  stopMicrophone: () => void;
  startPush: (pushUrl: string) => Promise<void>;
  stopPush: () => void;
  isPushing: () => boolean;
  destroy: () => void;
};

type TXLivePusherGlobal = {
  TXLivePusher?: TXLivePusherConstructor;
};

export type PusherRuntimeError = {
  errorCode: number;
  message: string;
};

export const getPusherUnavailableError = (): PusherRuntimeError => ({
  errorCode: PUSHER_ERROR_CODES.SDK_NOT_AVAILABLE,
  message: ERROR_MESSAGES[PUSHER_ERROR_CODES.SDK_NOT_AVAILABLE],
});

export const getTXLivePusherConstructor = (
  targetWindow: TXLivePusherGlobal = window as typeof window &
    TXLivePusherGlobal
): TXLivePusherConstructor | null => {
  const ctor = targetWindow.TXLivePusher;
  return typeof ctor === 'function' ? (ctor as TXLivePusherConstructor) : null;
};
